import { render, staticRenderFns } from "./Exercise5-2.vue?vue&type=template&id=16ad1cc9&"
import script from "./Exercise5-2.vue?vue&type=script&lang=js&"
export * from "./Exercise5-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports